const msConverter = ({ value, target, origin }) => {
  let convertedValue = ''

  const toSeconds = 1000
  const toMinutes = toSeconds * 60
  const toHours = toMinutes * 60
  const toDays = toHours * 24

  if (target === 'ms') {
    switch (origin) {
      case 'days':
        convertedValue = value * toDays
        break
      case 'hours':
        convertedValue = value * toHours
        break
      case 'minutes':
        convertedValue = value * toMinutes
        break
      default:
        convertedValue = value * toSeconds
        break
    }
  } else {
    switch (target) {
      case 'days':
        convertedValue = value / toDays
        break
      case 'hours':
        convertedValue = value / toHours
        break
      case 'minutes':
        convertedValue = value / toMinutes
        break
      default:
        convertedValue = value / toSeconds
        break
    }
  }

  return Math.floor(convertedValue)
}

export default msConverter
